export enum RoutesEnums {
  HOME = '',
  SEARCH = 'hitta',
  SEARCH_VARDGIVARE = 'vard',
  CAREPROVIDER = 'vardgivare',
  WEBVIEW = 'webview',
  CARESERVICE = 'behandling',
  BLOG = 'blogg',
  ARCHIVE = 'arkiv',
  TAG = 'kategori',
  NATIVES = 'artiklar',
  GUIDE = 'guider',
  PAGE = 'info',
  FOR_CAREPROVIDERS = 'blikund',
  ORGANIZATION = 'organization',
  ORGANIZATION_CREATEREVIEW = 'createreview',
  RATINGPOLICY = 'omdomenpolicy',
  AUTHOR = 'forfattare',
  NOTFOUND = 'hittadesinte',
  BOOKING = 'boka',
  AUTH = 'auth',
  AUTH_LOGIN = 'login',
  AUTH_LOGOUT = 'logout',
  MYPAGES = 'minasidor',
  CAMPAIGN = 'kampanj',
  // SITEOVERVIEW = 'siteoverview',
  RELATED = 'relaterade',
  // EMPTY_W_H = 'emptywh',
  // EMPTY = 'empty',
}

export enum RoutesAddonsEnums {
  CAREPROVIDER_CREATE_REVIEW = 'lamna-omdome',
  CAREPROVIDER_REVIEWS = 'omdomen',
  CAREPROVIDER_IMPRESSION = 'helhetsintryck',
  CAREPROVIDER_ABOUT = 'omoss',
  CAREPROVIDER_SERVICES = 'behandlingar',
  CAREPROVIDER_CONTACT = 'kontakt',
  CAREPROVIDER_SURVEY = 'survey',
  CAREPROVIDER_QUESTIONS = 'fragor',
  CAREPROVIDER_OPENHOURS = 'oppettider',
  CAREPROVIDER_MAP = 'karta',
  CAREPROVIDER_STAFF = 'personal',
  CAREPROVIDER_REFERRAL = 'referral',
  CAREPROVIDER_BOOKTIMENOW = 'booktimenow',
  CAREPROVIDER_BOOKTIMENOW_SIDEBAR = 'booktimenow-sidebar',
  CARESERVICE_BOKA = 'boka-tid',
  CARESERVICE_DETAILS = 'detaljer',
  CARESERVICE_ABOUT = 'om-mottagningen',
  CARESERVICE_REVIEWS = 'omdomen',
  CARESERVICE_STAFF = 'personal',
  CARESERVICE_CONTACT = 'kontakt',
  CARESERVICE_OPENHOURS = 'oppettider',
  CARESERVICE_MAP = 'karta',
  CARESERVICE_MORE = 'fler-tjanster',
  CARESERVICE_IMPRESSION = 'helhetsintryck',
  RELATED_CAREPROVIDER = 'vardgivare',
  RELATED_CARESERVICE = 'behandling',
  RELATED_SYMPTOM = 'symptom',
  SERP_SERVICES = 'behandlingar',
  SERP_CAREPROVIDERS = 'mottagningar',
}

export enum RoutesQueryParamsEnum {
  PREVIEW = 'preview',
  GOOGLE_AD_PREVIEW = 'google_preview',
  GOOGLE_AD_PREVIEW_IU = 'iu',
  GOOGLE_AD_PREVIEW_GDFP = 'gdfp_req',
  GOOGLE_AD_PREVIEW_LINEID = 'lineItemId',
  GOOGLE_AD_PREVIEW_CREATIVEID = 'creativeId',
  GCLID = 'gclid',
  UTM_CAMPAIGN = 'utm_campaign',
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_TERM = 'utm_term',
  UTM_CONTENT = 'utm_content',
  UTM_SIZE = 'utm_size',
  FBCLID = 'fbclid',
  REVIEW_RATING_KEY = 'reviewRatingKey',
  DEBUG_FLAGS = 'df',
  BOOKING_STEP = 'bokningssteg',
  BOOKING_SELECTED_DATETIME = 'bdt',
  BOOKING_SELECTED_SERVICE = 'bs',
  BOOKING_SELECTED_STAFFMEMBER = 'bm',
  BOOKING_CALENDAR_DATE = 'bcd',
  BOOKING_REFERRAL = 'ref',
  BOOKING_ALERT = 'ba',
  BOOKING_FORCE_CALENDAR_DATE = 'fbcd',
  BOOKING_NUMBER_OF_TIMESLOTS = 'nots',
  BOOKING_SERVICE_GROUP_ID = 'sgi',
  BOOKING_TIMESLOT_MATCH = 'tm',
  BOOKING_TWO_FACTOR_AUTH = 'tfa',
  WIDGET_LISTNING_ACTION = 'listning-widget-action',
  NEARBY = 'n',
}

export enum RoutesNamesEnum {
  HOME = 'Hitta vård',
  SEARCH = 'Sökresultat',
  BLOG = 'Blogg',
  ARCHIVE = 'Arkiv',
  TAG = 'Kategori',
  GUIDE = 'Våra guider',
  NATIVES = 'Artiklar',
  RELATED = 'Relaterade sökningar',
  CAREPROVIDER_REVIEWS = 'Omdömen',
  CAREPROVIDER_ABOUT = 'Om oss',
  CAREPROVIDER_SERVICES = 'Behandlingar',
  CAREPROVIDER_CONTACT = 'Kontakt och öppettider',
  CAREPROVIDER_QUESTIONS = 'Frågor & svar',
  CARESERVICE_BOKA = 'Boka tid',
  CARESERVICE_DETAILS = 'Detaljer',
  CARESERVICE_ABOUT = 'Om mottagningen',
  CARESERVICE_REVIEWS = 'Omdömen',
  CARESERVICE_STAFF = 'Personal',
  CARESERVICE_CONTACT = 'Kontakt & öppettider',
  CARESERVICE_MORE = 'Fler tjänster',
  RELATED_CAREPROVIDER = 'Vårdgivare',
  RELATED_CARESERVICE = 'Behandling',
  RELATED_SYMPTOM = 'Symptom',
}
